import { render, staticRenderFns } from "./PostManagement.vue?vue&type=template&id=bd9c1b7c&scoped=true"
import script from "./PostManagement.vue?vue&type=script&lang=js"
export * from "./PostManagement.vue?vue&type=script&lang=js"
import style0 from "@/assets/css/background/post.css?vue&type=style&index=0&id=bd9c1b7c&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd9c1b7c",
  null
  
)

export default component.exports